export const showMenu = (dom) => {
    let addEvent = () => {
        dom.classList.remove('show-menu');
    }
    dom.classList.add('show-menu');
    dom.addEventListener('webkitAnimationEnd', addEvent, false);
}

export const getUrlLogin = () => {
    let domain = window.location.hostname != 'localhost' ? window.location.hostname : '';
    document.cookie = 'message=Vui lòng đăng nhập; expires=' + new Date(Date.now() + 60000) + '; path=/; domain='+ domain;
    let href = location.href;
    window.location.href = process.env.VUE_APP_URL_LOGIN + '?redirect=' + btoa(href);
}

export function formatNumber(num) {
    if(!num && num !== '') return 0;
    num = num.toString().replace(/[^0-9]/g, '');
    num = num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    return num;
}
export function formatNumberPhome(phone) {
    if(typeof phone == "undefined") return '';
    phone = phone.toString();
    if(phone.substr(0, 2) == '+84'){
        phone = '0' + phone.substr(3);
    }
    phone = phone.replace(/[^0-9]/g, '');
    if(phone.length != 10){
        return phone;
    }
    return phone.substr(0, 4) + ' ' + phone.substr(4, 3) + ' ' + phone.substr(7, 3);
}
export function formatDate(date) {
    if(typeof date == "undefined") return '';
    var datePart = date.match(/\d+/g),
    year = datePart[0],
    month = datePart[1],
    day = datePart[2];

    return day+'/'+month+'/'+year;
}
export const checkDateInput = (date) => {
    let arrayDate = date.split('-');
    if(arrayDate.length != 3){
        return '';
    }else if(arrayDate[0].length != 4){
        return '';
    }else if(arrayDate[1].length != 2 || arrayDate[2].length != 2){
        return '';
    }else{
        return date;
    }
}

export const getDate = (date) => {
    if(!date) return '';
    let day = new Date(date);
    let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
    let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
    return dayNow + '/' + m + '/' + day.getFullYear();
}

export const getMoney = () => {
    apiGet('/v2/profile/money').then(res => {
        let data = res.data;
        window.$store.commit('dataMoney', data);
    })
}

export const stringToNumber = (number) => {
    number = number.toString().replace(/\./g, '');
    number = number.replace(/[^0-9]/g, '');
    if(number === '') number = 0;
    number = parseInt(number);
    return number;
}

export const getMinutes = (time) => {
    time = time.split(':');
    let minuteH = (time[0] ? time[0] : 0) * 60;
    let minuteM = (time[1] ? time[1] : 0) * 1;
    return minuteH + minuteM;
}

export const getDayInWeek = (day) => {
    let date = '';
    switch (day){
        case 'T2':
            date = 1;
            break;
        case 'T3':
            date = 2;
            break;
        case 'T4':
            date = 3;
            break;
        case 'T5':
            date = 4;
            break;
        case 'T6':
            date = 5;
            break;
        case 'T7':
            date = 6;
            break;
        default:
            date = 7;
    }
    return date;
}
export const getDayTextInWeek = (day) => {
    let date = '';
    switch (day){
        case 1:
            date = 'T2';
            break;
        case 2:
            date = 'T3';
            break;
        case 3:
            date = 'T4';
            break;
        case 4:
            date = 'T5';
            break;
        case 5:
            date = 'T6';
            break;
        case 6:
            date = 'T7';
            break;
        default:
            date = 'CN';
    }
    return date;
}

export const pictureProductThumb = (filename, max_width, max_height) => {
	if (filename == "" || typeof filename == "undefined") return '';
	if (typeof max_width == "undefined") max_width = 0;
	if (typeof max_height == "undefined") max_height = 0;

	max_width = Number(max_width);
	max_height = Number(max_height);

	let timeFile = filename.replace(/[^0-9]/g, '').substr(-10, 10);
	timeFile = Number(timeFile);
	let dateFile = new Date(timeFile * 1000);

	if(dateFile.getFullYear() > new Date().getFullYear())
		timeFile 	=	0;

	let ext 	=	"";
	if (max_width > 0 && max_height > 0)
	{
		ext 	=	max_width + "x" + max_height;
	}
	else if(max_width > 0)
	{
		ext 	=	"w" + max_width;
	}
	else if(max_height > 0)
	{
		ext 	=	"h" + max_height;
	}
	else
	{
		ext 	=	max_width + "x" + max_height;
	}

	return "https://cdnvg.scandict.com/pictures/thumb/" + ext + "/" + dateFile.getFullYear() + "/" + dateFile.getMonth() + "/" + filename;
}
